var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileFooterWave(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 754,
    height: 792,
    viewBox: "0 0 754 792",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_201_417)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 754,
    height: 792,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.878302 199C1.467 198.7 2.05721 198.403 2.64892 198.109C38.3721 180.377 66.2941 148.562 80.432 107.659C80.6145 107.133 80.8004 106.608 80.9875 106.086C105.601 37.6407 176.579 10.633 240.26 45.5067C240.625 45.7052 240.988 45.9074 241.349 46.1106C258.457 55.6877 277.903 55.4126 293.144 45.4727C380.039 -11.2013 493.926 -17.2442 599.113 40.6373C665.168 76.9855 717.98 133.213 753.708 199H754V792H0V199.451V199H0.878302Z",
    fill: "url(#paint0_linear_201_417)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_201_417",
    x1: 0,
    y1: 396,
    x2: 754,
    y2: 396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC0000"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_201_417"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 754,
    height: 792,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileFooterWave);
export default __webpack_public_path__ + "static/media/mobile-footer-wave.f85c9e4216a68e36b2ab69facbd4f781.svg";
export { ForwardRef as ReactComponent };